import React from 'react'

import { useDashboardFeatureFlags } from '@components'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { HeadContent } from '@fourthwall/components'

import { HMAC } from './modules/HMAC'
import { Headless } from './modules/Headless'
import { OpenAPI } from './modules/OpenAPI'
import { Webhooks } from './modules/Webhooks'

export const ForDevelopers = () => {
  const { hasPermission } = useDashboardPermissions()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  return (
    <>
      <HeadContent title="For developers &ndash; Settings" />

      {hasPermission('settings.forDevelopers.openAPI') && <OpenAPI />}

      {hasPermission('settings.forDevelopers.webhooks') && <Webhooks />}

      {hasPermission('settings.forDevelopers.headless') && <Headless />}

      {hasPermission('settings.forDevelopers.hmac') && dashboardFeatureFlags.developersHMAC && (
        <HMAC />
      )}
    </>
  )
}
